import { useState } from 'react';
import type { FC } from 'react';

import classNames from 'classnames';

import { DevOnly } from 'src/app/components/Elements/DevOnly';
import { LOCATIONS } from 'src/consts';

import styles from './styles.module.scss';

interface LocationDebuggerProps {
  locationSelect: (location: string) => void;
  preferredLocation: string;
}

/**
 * @usage
 * - To display, add `?showLocationDebug=true` to the end of your URL
 * - To hide, add `?showLocationDebug=false`
 */
const LocationDebugger: FC<LocationDebuggerProps> = ({ locationSelect, preferredLocation }) => {
  const [showDebugger, setShowDebugger] = useState(true);
  const toggleShowDebugger = () => {
    setShowDebugger(s => !s);
  };
  return (
    <DevOnly className={classNames(styles.component, 'logged-in', { [styles.isHidden]: !showDebugger })}>
      <button className={styles.showButton} onClick={toggleShowDebugger}>
        {showDebugger ? 'hide' : 'show'} location debugger
      </button>
      {showDebugger && (
        <div className={classNames(styles.innerContainer, { [styles.active]: showDebugger })}>
          {Object.keys(LOCATIONS).map(keyName => (
            <div
              className={classNames(styles.locationItem, {
                [styles.selected]: LOCATIONS[keyName] === preferredLocation,
              })}
              onClick={() => locationSelect(LOCATIONS[keyName])}
              key={LOCATIONS[keyName]}
            >
              {LOCATIONS[keyName]}
            </div>
          ))}
        </div>
      )}
    </DevOnly>
  );
};

export default LocationDebugger;
